import theme from '@/styles/theme';

interface SkeletonProps {
  width?: string;
  height?: string;
  rounded?: 'none' | 'sm' | 'md' | 'lg' | 'full';
  speed?: 'slow' | 'normal' | 'fast';
  className?: string;
}

const roundedMap = {
  none: 'tw:rounded-none',
  sm: 'tw:rounded',
  md: 'tw:rounded-md',
  lg: 'tw:rounded-lg',
  full: 'tw:rounded-full',
};

const speedMap = {
  slow: '2.5s',
  normal: '1.5s',
  fast: '0.8s',
};

export default function Skeleton({
  width = '100%',
  height = '16px',
  rounded = 'md',
  speed = 'normal',
  className = '',
}: SkeletonProps) {
  return (
    <div
      className={`tw:animate-shimmer ${roundedMap[rounded]} ${className}`}
      style={{
        width,
        height,
        animationDuration: speedMap[speed],
        backgroundImage: `linear-gradient(90deg, ${theme.colors.gray4} 0%, ${theme.colors.gray5} 40%, ${theme.colors.gray4} 80%)`,
        backgroundSize: '200% 100%',
      }}
    />
  );
}
